import type {
	ApplyTemplateLibraryEntryResponse,
	ListTemplateLibraryEntriesResponse,
	TemplateLibraryEntryDetail,
	TemplateLibraryEntryTypeEnum,
} from "@performyard/service-contracts";

import request from "./internal-api/internal-base-request";

// GET /v1/template-library/entries
export const fetchTemplateLibraryEntries = async (
	type?: TemplateLibraryEntryTypeEnum
): Promise<ListTemplateLibraryEntriesResponse> => {
	const url = type ? `/v1/template-library/entries?type=${encodeURIComponent(type)}` : "/v1/template-library/entries";
	const [response] = await request<ListTemplateLibraryEntriesResponse>(url, { method: "GET" });
	return response;
};

// GET /v1/template-library/entries/:entryId
export const fetchTemplateLibraryEntry = async (entryId: string): Promise<TemplateLibraryEntryDetail> => {
	const [response] = await request<TemplateLibraryEntryDetail>(`/v1/template-library/entries/${entryId}`, {
		method: "GET",
	});
	return response;
};

// POST /v1/template-library/entries/:entryId/apply
export const applyTemplateLibraryEntry = async (entryId: string): Promise<ApplyTemplateLibraryEntryResponse> => {
	const [response] = await request<ApplyTemplateLibraryEntryResponse>(
		`/v1/template-library/entries/${entryId}/apply`,
		{ method: "POST", body: JSON.stringify({}) }
	);
	return response;
};
